import { render } from "./TemplateRegister.vue?vue&type=template&id=fef1233e&scoped=true&ts=true"
import script from "./TemplateRegister.vue?vue&type=script&lang=ts"
export * from "./TemplateRegister.vue?vue&type=script&lang=ts"

import "./TemplateRegister.vue?vue&type=style&index=0&id=fef1233e&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef1233e"]])

export default __exports__